import { TrackQueryConfig } from '../../../models';

export const DEFAULT_TRACK_QUERY_CONFIG: TrackQueryConfig = {
  debounceTimeInMs: 2000
};
